import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.854 9.098a.833.833 0 0 1 1.14 1.215l-.02.019-1.427 1.297a.833.833 0 0 1-1.142-1.214l.02-.02zM2.194 3.692a2.708 2.708 0 0 1 3.24-1.934l.042.01 12.241 3.106a.917.917 0 0 1 .41 1.55l-.018.017-4.804 4.365a.916.916 0 0 1-.745.23l-.03-.005-4.028-.706a.833.833 0 0 1 .262-1.645l.025.004 3.666.642 3.5-3.18L5.067 3.384a1.042 1.042 0 0 0-1.255.712l-.008.028-.534 1.995c-.145.54.162 1.096.692 1.263l.028.008 1.253.358c.586.167.992.695 1.007 1.301V15.625a2.708 2.708 0 0 1-2.664 2.708H2.5a.833.833 0 0 1-.026-1.666h1.068c.565 0 1.026-.452 1.04-1.014l.001-.028V9.293l-1.05-.3A2.708 2.708 0 0 1 1.65 5.731l.01-.043z"
    }, null, -1)
  ])))
}
export default { render: render }